module.exports = __webpack_public_path__ + "static/media/hexagon-bg.05eb5eb2.svg";